import styled from 'styled-components'

const DatePickerStyled = styled.div`
  position: relative;
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    margin-left: -8px;
    position: absolute;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    content: '';
    z-index: -1;
    border-width: 8px;
    left: -8px;
    border-bottom-color: ${props => props.theme.palette.white};
    top: 0px;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-top: none;
    border-bottom-color: ${props => props.theme.palette.white};
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    bottom: 0;
    margin-bottom: -8px;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    border-bottom: none;
    border-top-color: #fff;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    display: none;
  }

  .react-datepicker-popper[data-placement^='top'] {
    margin-bottom: 10px;
  }

  .react-datepicker-wrapper {
    display: inline-block;
    width: 100%;
    padding: 0;
    border: 0;
  }

  .react-datepicker {
    display: ${props => (props.isVisible ? 'inline-block' : 'none')};
    position: absolute;
    width: 328px;
    box-shadow: 0px 4px 20px rgba(96, 96, 96, 0.2);
    border-radius: 12px;
    background-color: ${props => props.theme.palette.white};
    font-size: 16px;
    filter: drop-shadow(0px 4px 20px rgba(96, 96, 96, 0.4));
    border: none;
  }

  .react-datepicker-popper {
    z-index: 1090;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    margin-top: 10px;
  }

  .react-datepicker-popper[data-placement^='left'] {
    margin-right: 8px;
  }

  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {
    left: 42px;
    right: auto;
  }

  .react-datepicker__header {
    text-align: center;
    position: relative;
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.palette.grey5};
    margin: 0 0 4px 0;
    padding: 0;
    background-color: ${props => props.theme.palette.white};
    border-radius: 12px 12px 0px 0px;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
  }

  .react-datepicker__current-month,
  .react-datepicker-year-header {
    margin-top: 0;
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    padding: 16px 0;
    line-height: 24px;
    color: ${props => props.theme.palette.grey1};
  }

  .react-datepicker__navigation {
    background: none;
    line-height: 1.7rem;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 10px;
    padding: 0;
    z-index: 1;
    overflow: hidden;
    height: 20px;
    width: 20px;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }

  .react-datepicker__navigation--previous {
    left: 16px;
  }

  .react-datepicker__navigation--next {
    right: 16px;
  }

  .react-datepicker__month-container {
    float: left;
    width: 100%;
  }

  .react-datepicker__year .react-datepicker__year-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__month {
    margin: 6px 9px 9px;
    text-align: center;
  }

  .react-datepicker__day-name,
  .react-datepicker__day {
    color: #000;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__day {
    cursor: pointer;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day:hover {
    border-radius: 0.3rem;
    background: rgba(237, 17, 100, 0.08);
  }

  .react-datepicker__day--disabled:hover {
    background-color: transparent;
  }

  .react-datepicker__month-text.react-datepicker__month--selected:hover {
    background-color: #216ba5;
  }

  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  /** CUSTOM  */

  .react-datepicker__day--outside-month {
    margin: 20px;
    color: ${props => props.theme.palette.grey6} !important;
  }

  .react-datepicker__month-select,
  .react-datepicker__year-select {
    outline: none;
    position: relative;
    margin: 0 0 16px 0;
    padding: 6px 12px;
    background: ${props => props.theme.palette.whiteGrey};
    border-radius: 8px;
    border: none;
    color: ${props => props.theme.palette.grey1};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    -webkit-appearance: none;
    appearance: none;
    -moz-appearance: none;
    width: 80px;
    :hover {
      background: ${props => props.theme.palette.grey5};
    }
  }

  .react-datepicker__month-select {
    width: 120px;
  }

  .react-datepicker__month-dropdown-container {
    margin-right: 16px;
  }

  .react-datepicker__month-dropdown-container,
  .react-datepicker__year-dropdown-container {
    position: relative;
  }
  .react-datepicker__month-dropdown-container::after,
  .react-datepicker__year-dropdown-container::after {
    position: absolute;
    pointer-events: none;
    right: 12px;
    border: solid ${props => props.theme.palette.grey3};
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 2px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    content: '';
    top: 26%;
  }

  div[class*='react-datepicker__day--00']::before {
    content: '0';
  }

  .react-datepicker__day-name,
  .react-datepicker__day {
    padding: 6px 10px !important;
    width: auto;
    min-width: 40px;
    margin: 2px;
    color: ${props => props.theme.palette.grey1};
    background: ${props => props.theme.palette.white};
  }

  .react-datepicker__day--selected {
    background: ${props => props.theme.palette.burgundy1};
    &:hover {
      background: ${props => props.theme.palette.burgundy5};
      color: ${props => props.theme.palette.black};
    }
    color: ${props => props.theme.palette.white};
  }
  .react-datepicker__year-select::-ms-expand,
  .react-datepicker__month-select::-ms-expand {
    display: none;
  }

  .react-datepicker__day--disabled {
    cursor: default;
    color: #c4c4c4;
    pointer-events: none;
  }
`

export default DatePickerStyled
